/**
 * 全局变量
 */

export const CLIENT_TYPE = {
  phone: {
    0: 'PC',
    1: '安卓',
    2: 'IOS'
  },
  gender: {
    1: '男',
    2: '女'
  },
  net: {
    0: ' -- ',
    1: '在线',
    2: '忙碌'
  },
  role: {
    0: ' -- ',
    1: '主播'
  },
  vip: {
    0: ' -- ',
    1: 'VIP'
  }
}

export const ORDER_TYPE = {
  name: {
    'gold': '金币',
    'vip': '会员'
  },
  status: {
    0: '',
    1: '成功',
    2: '电子账单',
    3: '退款'
  },
  sandbox: {
    0: '正式',
    1: '测试'
  },
  way: {
    0: 'PayPal',
    1: '安卓',
    2: 'IOS',
  }
}
export const MENU_TYPE = {
  name: {
    'gold': '金币',
    'vip': '会员'
  },
  status: {
    0: '',
    1: '成功',
    2: '电子账单',
    3: '退款'
  },
  sandbox: {
    0: '正式',
    1: '测试'
  },
  way: {
    0: 'PayPal',
    1: '安卓',
    2: 'IOS',
  }
}
export const COST_TYPE = {
  type: {
    '1': '通话',
    '2': '翻译',
  }
}

export let Dict = {
  /**
   * 分红类型
   */
  share_type: {
    //合伙人
    partner: {11: '充电分红', 12: '广告分红', 13: '平台分红'},
    //代理
    agent: {21: '线下佣金', 22: '线上佣金'},
    //经销商
    dealer: {31: '省', 32: '市', 33: '县', 34: '乡镇', 35: '社区'},
    //分公司
    branch: {41: '充电分红', 42: '安装分红'}
  },

  device: {
    kind_map: {'1': '电动车', '2': '新能源'},
  },
  energy: {
    status: {0: '', 1: '充电中', 2: '已结束'},
    end_type: {1: '充满自停', 2: '手动结束', 3: '费用不足',4:'功率过载',5:'空载',6:"充电结束",20:'异常结束'},
    way_list: ['按功率定额计费', '分功率阶段计费','按度数计费(选填)','电单车按度数计费']
  }
}



// WEBPACK FOOTER //
// ./src/utils/dict.js